<template>
  <div class="changePw-dialog">
    <div class="title">找回密码</div>
    <div class="content">
      <div class="telephone">
        <span>手机号</span>
        <el-input
          v-model="telephone"
          placeholder="请输入手机号"
          maxlength="11"
          size="medium"
        ></el-input>
        <div
          class="send-btn"
          :class="{ 'disabled-send-btn': sendingVerifyCode }"
          @click="sendVerifyCode"
        >
          {{ verifyCodeBtnText }}
        </div>
      </div>
      <div class="verifyCode">
        <span>验证码</span>
        <el-input
          v-model="verifyCode"
          placeholder="请输入验证码"
          size="medium"
        ></el-input>
      </div>
      <div class="password">
        <span>密码</span>
        <el-input
          v-model="password"
          show-password
          placeholder="请输入密码"
          size="medium"
        ></el-input>
      </div>
      <div class="re-password">
        <span>确认密码</span>
        <el-input
          v-model="rePassword"
          show-password
          placeholder="请重复输入密码"
          size="medium"
        ></el-input>
      </div>
      <div
        class="confirm-btn"
        :click="{ 'disabled-btn': submitting }"
        @click="confirmPw"
        v-loading="submitting"
      >
        确认修改
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      telephone: "",
      verifyCode: "",
      password: "",
      rePassword: "",
      submitting: false,
      sendingVerifyCode: false,
      timerCounter: 60,
      verifyCodeBtnText: "发送验证码"
    };
  },
  methods: {
    async confirmPw() {
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      if (this.telephone.length !== 11) {
        this.submitting = false;
        this.$message.error("请输入正确的手机号！");
        return;
      }
      if (this.verifyCode.length === 0) {
        this.submitting = false;
        this.$message.error("请输入验证码！");
        return;
      }
      if (this.password.length === 0) {
        this.submitting = false;
        this.$message.error("请输入密码！");
        return;
      }
      if (this.rePassword.length === 0) {
        this.submitting = false;
        this.$message.error("请输入确认密码！");
        return;
      }
      if (this.password !== this.rePassword) {
        this.submitting = false;
        this.$message.error("密码与确认密码不一致！");
        return;
      }

      this.submitting = true;
      const params = {
        phone: this.telephone,
        password: this.password,
        checkCode: this.verifyCode,
        rePassword: this.rePassword
      };
      const res = await httpRequest("/app/user/rePassword", "put", params);
      if (res !== null && res !== undefined && res.code === 200) {
        this.$message.success("修改成功，请重新登录");
        // 跳转到首页
        this.$router.push({ path: "/login" });
      } else {
        this.submitting = false;
      }
    },
    async sendVerifyCode() {
      if (this.submitting || this.sendingVerifyCode) {
        return;
      }
      if (this.telephone.length !== 11) {
        this.sendingVerifyCode = false;
        this.$message.error("请输入正确的手机号！");
        return;
      }
      this.sendingVerifyCode = true;
      const params = {
        phone: this.telephone
      };
      const res = await httpRequest("/common/sms", "put", params);
      if (res !== null && res !== undefined && res.code === 200) {
        const _this = this;
        this.sendingVerifyCode = true;
        this.$message.success(
          "验证码已发送到" + this.telephone + "，请注意查收"
        );
        setInterval(function() {
          if (_this.timerCounter <= 0) {
            clearInterval();
            _this.verifyCodeBtnText = "重新发送";
            _this.sendingVerifyCode = false;
          } else {
            _this.verifyCodeBtnText = "重新发送(" + _this.timerCounter-- + "s)";
          }
        }, 1000);
      } else {
        this.sendingVerifyCode = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.changePw-dialog {
  width: 850px; // Match production extraction
  background: #ffffff;
  margin: 100px auto;
  padding: 40px;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

  .title {
    height: 60px;
    line-height: 60px;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #035DB3; // Blue Theme
    text-align: center;
    background: transparent;
    margin-bottom: 20px;
  }
  .content {
    width: 600px;
    margin: 0 auto; // Center content
    
    .telephone, .verifyCode, .password, .re-password {
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      
      span {
        display: inline-block;
        width: 80px;
        text-align: right;
        margin-right: 15px;
        font-size: 16px;
        color: #333;
      }
      .el-input {
        width: 320px;
      }
    }
    
    .telephone {
      .send-btn {
        display: inline-block;
        width: 130px;
        height: 36px;
        line-height: 36px;
        border: 1px solid #035DB3; // Blue Theme
        margin-left: 20px;
        font-size: 14px;
        color: #035DB3; // Blue Theme
        border-radius: 4px;
        cursor: pointer;
        text-align: center;
        
        &:hover {
          background-color: #f0f7ff;
        }
      }
      .disabled-send-btn {
        color: #999 !important;
        border-color: #ebeef5 !important;
        cursor: not-allowed !important;
        background-color: #f5f7fa;
      }
    }

    .confirm-btn {
      width: 400px;
      height: 45px;
      line-height: 45px;
      background: #035DB3; // Blue Theme
      border-radius: 10px;
      margin: 50px auto 0;
      font-size: 18px;
      color: #ffffff;
      cursor: pointer;
      text-align: center;
      
      &:hover {
        opacity: 0.9;
      }
    }
    .disabled-btn {
      cursor: not-allowed !important;
      opacity: 0.7;
    }
  }
}
</style>
